<template>
  <div v-loading.fullscreen="loading">
    <div class="header-scroll">
      <div class="header">
        <el-input
          v-model="search"
          placeholder="Ism yoki PINFL bo'yicha qidirish"
          clearable
          class="header-control"
          @input="onSearch"
          @clear="onSearch"
        />

        <el-select v-model="status_filter" placeholder="Holat" clearable class="header-control" @change="getManagers">
          <el-option label="Faol"       :value="1" />
          <el-option label="Nofaol"     :value="2" />
          <el-option label="Bloklangan" :value="3" />
          <el-option label="Jarayonda"  :value="4" />
        </el-select>

        <el-button
          class="header-button header-button--right"
          type="info"
          @click="$router.push({ name: 'ManagerLogs' })"
        >
          Loglar
        </el-button>

        <el-button
          class="header-button"
          type="primary"
          @click="openCreateDialog"
        >
          Qo'shish
        </el-button>
      </div>
    </div>

    <el-table :data="managers" border height="calc(100vh - 270px)">
      <el-table-column type="index" :index="indexMethod" width="60" />
      <el-table-column prop="fullname" label="Ismi Sharifi" min-width="220" />
      <el-table-column prop="pinfl" label="PINFL" min-width="160" />
      <el-table-column prop="region_title" label="Viloyat" min-width="170" />
      <el-table-column prop="district_title" label="Tuman/Shahar" min-width="170" />
      <el-table-column prop="created_at" label="Yaratilgan vaqti" min-width="170">
        <template #default="scope">
          {{
            scope.row.created_at
              ? $moment(scope.row.created_at).format("DD-MM-YYYY / HH:mm")
              : "-"
          }}
        </template>
      </el-table-column>
      <el-table-column label="Holat" min-width="130">
        <template #default="scope">
          <el-tag :type="statusTagType(scope.row.status)" effect="light">
            {{ statusLabel(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column width="320" label="Amallar" fixed="right">
        <template #default="scope">
          <el-button size="small" type="primary" @click="openEditDialog(scope.row)">Tahrirlash</el-button>
          <el-button size="small" type="danger" @click="onDelete(scope.row)">O'chirish</el-button>
          <el-button
            v-if="$store.state.role === 'admin'"
            size="small"
            type="info"
            @click="showHistory(scope.row.id)"
          >Holat tarixi</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <div>Boshqaruvchilar soni: {{ totalCount }}</div>
      <el-pagination
        background
        layout="sizes, prev, pager, next"
        :total="totalCount"
        v-model:page-size="limit"
        v-model:current-page="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      v-model="showDialog"
      :title="form.id ? 'Boshqaruvchini tahrirlash' : 'Boshqaruvchi qo\'shish'"
      width="560px"
      @closed="resetForm"
    >
      <el-form ref="formRef" :model="form" :rules="rules" label-position="top">
        <el-form-item label="Ismi Sharifi" prop="fullname">
          <el-input
            v-model="form.fullname"
            size="large"
            placeholder="Ism Familiya"
          />
        </el-form-item>

        <el-form-item label="PINFL" prop="pinfl">
          <el-input
            v-model="form.pinfl"
            size="large"
            maxlength="14"
            inputmode="numeric"
            placeholder="14 ta raqam"
            @input="onPinflInput"
          />
        </el-form-item>

        <el-form-item label="Viloyat" prop="region_id">
          <el-select
            v-model="form.region_id"
            style="width: 100%"
            size="large"
            placeholder="Viloyatni tanlang"
            :loading="regionsLoading"
            @change="onChangeRegion"
          >
            <el-option
              v-for="region in regions"
              :key="region.id"
              :value="region.id"
              :label="region.title"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Tuman/Shahar" prop="district_id">
          <el-select
            v-model="form.district_id"
            style="width: 100%"
            size="large"
            placeholder="Tumanni tanlang"
            :loading="districtsLoading"
          >
            <el-option
              v-for="district in districts"
              :key="district.id"
              :value="district.id"
              :label="district.title"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Holat" v-if="form.id">
          <el-select v-model="form.status" style="width: 100%" size="large">
            <el-option label="Faol"   :value="1" />
            <el-option label="Nofaol" :value="2" />
          </el-select>
        </el-form-item>

        <el-form-item label="Sabab (ixtiyoriy)" v-if="form.id && form.status !== originalManagerStatus">
          <el-input type="textarea" :rows="2" v-model="form.status_reason" />
        </el-form-item>
      </el-form>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="showDialog = false">Bekor qilish</el-button>
          <el-button type="primary" :loading="saving" @click="onSubmit">
            Saqlash
          </el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog v-model="historyDialog" title="Holat tarixi" width="800px">
      <div v-loading="historyLoading">
        <el-table :data="historyData" border size="small">
          <el-table-column label="Sana" min-width="140">
            <template #default="scope">{{ $moment(scope.row.changed_at).format("DD-MM-YYYY HH:mm") }}</template>
          </el-table-column>
          <el-table-column label="Oldingi holat" min-width="120">
            <template #default="scope">
              <el-tag :type="statusTagType(scope.row.old_status)" size="small" effect="light">{{ statusLabel(scope.row.old_status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="Yangi holat" min-width="120">
            <template #default="scope">
              <el-tag :type="statusTagType(scope.row.new_status)" size="small" effect="light">{{ statusLabel(scope.row.new_status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="changed_by_fullname" label="Kim o'zgartirdi" min-width="160" />
          <el-table-column prop="reason" label="Sabab" min-width="160" />
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";

export default {
  name: "DeputyManagerList",
  data() {
    const validatePinfl = (rule, value, callback) => {
      if (!value) {
        callback(new Error("Majburiy maydon"));
        return;
      }
      if (!/^\d{14}$/.test(value)) {
        callback(new Error("PINFL 14 ta raqamdan iborat bo'lishi kerak"));
        return;
      }
      callback();
    };

    return {
      loading: false,
      saving: false,
      regionsLoading: false,
      districtsLoading: false,
      managers: [],
      totalCount: 0,
      limit: 20,
      currentPage: 1,
      search: "",
      searchTimer: null,
      status_filter: null,
      regions: [],
      districts: [],
      showDialog: false,
      // Keeps the original PINFL to warn the admin when it changes on edit.
      originalPinfl: "",
      originalManagerStatus: null,
      historyDialog: false,
      historyLoading: false,
      historyData: [],
      form: {
        id: null,
        fullname: "",
        pinfl: "",
        region_id: null,
        district_id: null,
        status: null,
        status_reason: "",
      },
      rules: {
        fullname: [{ required: true, message: "Majburiy maydon", trigger: "blur" }],
        pinfl: [{ validator: validatePinfl, trigger: "blur" }],
        region_id: [{ required: true, message: "Majburiy maydon", trigger: "change" }],
        district_id: [{ required: true, message: "Majburiy maydon", trigger: "change" }],
      },
    };
  },
  methods: {
    showHistory(id) {
      this.historyData = [];
      this.historyDialog = true;
      this.historyLoading = true;
      this.$http.get(`/api/v1/managers/${id}`)
        .then(({ data }) => { this.historyData = data.status_history || []; })
        .catch(() => {})
        .finally(() => { this.historyLoading = false; });
    },
    statusLabel(status) {
      const map = { 1: "Faol", 2: "Nofaol", 3: "Bloklangan", 4: "Jarayonda" };
      return map[status] || "-";
    },
    statusTagType(status) {
      const map = { 1: "success", 2: "danger", 3: "danger", 4: "warning" };
      return map[status] || "info";
    },
    indexMethod(index) {
      return this.limit * (this.currentPage - 1) + index + 1;
    },
    getManagers() {
      this.loading = true;
      this.$http
        .get("/api/v1/managers", {
          params: {
            // role is REQUIRED by the backend on this endpoint.
            role: "deputy_manager",
            search: this.search || null,
            status: this.status_filter,
            limit: this.limit,
            offset: this.limit * (this.currentPage - 1),
          },
        })
        .then(({ data }) => {
          this.managers = data.users || [];
          this.totalCount = data.count || 0;
        })
        .catch(({ response }) => {
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: response?.data?.message || "Yuklashda xatolik sodir bo'ldi",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.currentPage = 1;
        this.getManagers();
      }, 400);
    },
    getRegions() {
      this.regionsLoading = true;
      this.$http
        .get("/api/v1/regions")
        .then(({ data }) => {
          this.regions = data.regions || [];
        })
        .catch(() => {})
        .finally(() => {
          this.regionsLoading = false;
        });
    },
    getDistricts(regionId) {
      if (!regionId) {
        this.districts = [];
        return;
      }
      this.districtsLoading = true;
      this.$http
        .get("/api/v1/districts", { params: { region_id: regionId } })
        .then(({ data }) => {
          this.districts = data.districts || [];
        })
        .catch(() => {})
        .finally(() => {
          this.districtsLoading = false;
        });
    },
    onChangeRegion() {
      this.form.district_id = null;
      this.districts = [];
      this.getDistricts(this.form.region_id);
    },
    onPinflInput(value) {
      this.form.pinfl = String(value || "")
        .replace(/\D/g, "")
        .slice(0, 14);
    },
    openCreateDialog() {
      this.resetForm();
      if (!this.regions.length) this.getRegions();
      this.showDialog = true;
    },
    openEditDialog(row) {
      if (!this.regions.length) this.getRegions();
      this.originalPinfl = row.pinfl || "";
      this.originalManagerStatus = row.status ?? null;
      this.form = {
        id: row.id,
        fullname: row.fullname || "",
        pinfl: row.pinfl || "",
        region_id: row.region_id ?? null,
        district_id: row.district_id ?? null,
        status: row.status ?? null,
        status_reason: "",
      };
      this.getDistricts(this.form.region_id);
      this.showDialog = true;
    },
    resetForm() {
      this.form = {
        id: null,
        fullname: "",
        pinfl: "",
        region_id: null,
        district_id: null,
        status: null,
        status_reason: "",
      };
      this.originalPinfl = "";
      this.originalManagerStatus = null;
      this.districts = [];
      this.$refs.formRef?.clearValidate();
    },
    buildPayload() {
      // region_id is intentionally NOT sent — the backend derives it from
      // district_id. role is always included so the backend keeps regenerating
      // the username/phone correctly when the PINFL changes (spec B4).
      const payload = {
        fullname: this.form.fullname.trim(),
        pinfl: String(this.form.pinfl),
        role: "deputy_manager",
        district_id: this.form.district_id,
      };
      if (this.form.id && this.form.status !== null) {
        payload.status = this.form.status;
        if (this.form.status_reason) {
          payload.status_reason = this.form.status_reason;
        }
      }
      return payload;
    },
    onSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;

        const pinflChanged = this.form.id && this.form.pinfl !== this.originalPinfl;
        if (pinflChanged) {
          ElMessageBox.confirm(
            "PINFL o'zgartirilmoqda. Agar bu PINFL boshqa boshqaruvchiga tegishli bo'lsa, " +
              "o'sha hisob o'chiriladi. Davom etasizmi?",
            "Diqqat!",
            {
              confirmButtonText: "Ha",
              cancelButtonText: "Bekor qilish",
              type: "warning",
            }
          )
            .then(() => this.saveManager())
            .catch(() => {});
          return;
        }

        this.saveManager();
      });
    },
    saveManager() {
      this.saving = true;
      const payload = this.buildPayload();
      const request = this.form.id
        ? this.$http.put(`/api/v1/managers/${this.form.id}`, payload)
        : this.$http.post("/api/v1/managers", payload);

      request
        .then(() => {
          ElNotification({
            title: "Tabriklaymiz",
            message: "Muvaffaqiyatli saqlandi",
            type: "success",
          });
          this.showDialog = false;
          this.getManagers();
        })
        .catch(({ response }) => {
          ElNotification({
            title: "Xatolik",
            message: response?.data?.message || "Iltimos, qayta urinib ko'ring.",
            type: "error",
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    onDelete(row) {
      ElMessageBox.confirm(
        "Boshqaruvchi o'chirilsinmi? U endi tizimga kira olmaydi.",
        "Diqqat!",
        {
          confirmButtonText: "Ha",
          cancelButtonText: "Bekor qilish",
          type: "warning",
        }
      )
        .then(() => {
          this.loading = true;
          this.$http
            .delete(`/api/v1/managers/${row.id}`)
            .then(() => {
              ElMessage({ type: "success", message: "Boshqaruvchi o'chirildi" });
              if (this.managers.length === 1 && this.currentPage > 1) {
                this.currentPage -= 1;
              }
              this.getManagers();
            })
            .catch(({ response }) => {
              ElNotification({
                type: "error",
                title: "Xatolik",
                message: response?.data?.message || "Iltimos, qayta urinib ko'ring",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    handleCurrentChange() {
      this.getManagers();
    },
    handleSizeChange() {
      this.currentPage = 1;
      this.getManagers();
    },
  },
  mounted() {
    this.getManagers();
    this.getRegions();
  },
};
</script>

<style scoped>
.header-scroll {
  overflow-x: auto;
  overflow-y: hidden;
  margin-bottom: 10px;
}

.header {
  display: flex;
  gap: 10px;
  align-items: center;
}

.header-control {
  width: 320px;
  flex-shrink: 0;
}

.header-button {
  flex-shrink: 0;
}

.header-button--right {
  margin-left: auto;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}
</style>
